@if (contact) {
  <div class="contact-item">
    <div class="contact-item__header">
      <app-avatar
        [size]="46"
        [fontSizeOverride]="15"
        [displayName]="contact.name || ''"
        [photoUrl]="contact.photoUrl"
        color="var(--sgl-avatar-person)"
        textColor="var(--sgl-avatar-person-text)"></app-avatar>
      <div class="contact-item__header--details">
        <span class="contact-item__header--name">{{ contact.name }}</span>
        @if (contact.title) {
          <span class="contact-item__header--title">{{ contact.title }}</span>
        }
        <span class="contact-item__header--job-title">{{ contact.jobTitle }}</span>
      </div>
    </div>
    <app-contact-rows [contact]="contact" cardType="person"></app-contact-rows>
  </div>
}
